import { useRouter } from "next/router";
import { useContext, useEffect } from "react"
import { AuthContext } from "../../contexts/AuthContext"
import { login } from "../../util/account";

export const AuthGuard = ({ children }: any) => {
    const { isLoggedIn, isLoading } = useContext(AuthContext);
    const router = useRouter();

    useEffect(() => {
        if (!isLoading && !isLoggedIn) {
            login(router);
        }
    }, [isLoading, isLoggedIn]);

    if (isLoading) {
        return null;
    }

    if (isLoggedIn) {
        return children;
    }
}

export const withAuth = (component: any) => {
    return (
        <AuthGuard>
            {component}
        </AuthGuard>
    )
}